import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tez',
  templateUrl: './tez.component.html',
  styleUrls: ['./tez.component.scss'],
})
export class TezComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  get tezosString() {
    return navigator.userAgent.match(/ipad|iphone/i) ? 'tez' : 'ꜩ';
  }
}
